

import { removeInternalUserToken } from "../../common";
import { internalUserTokenName } from "../../config";

const getInternalUserFromLocalStorage = () => {
    try {
        const internaluser = JSON.parse(sessionStorage.getItem(internalUserTokenName));
        if (internaluser && internaluser.authToken && internaluser.loggedInTime) {
            console.log("Returning Internal User:", internaluser);
            return internaluser;
        } else {
            removeInternalUserToken();
            return null
        }
    } catch (error) {
        removeInternalUserToken()
        return null
    }
};


const getInitial = () => {
    return getInternalUserFromLocalStorage();
};

const internalUserReducer = (state = getInitial(), action) => {
    switch (action.type) {
        case "LOGIN_INTERNAL_USER":
            state = {};
            const time = action.payload.loggedInTime;
            if (time) {
                state.loggedInTime = time;
            } else {
                state.loggedInTime = Date.now();
            }
            state.authToken = action.payload.authToken;
            sessionStorage.setItem(internalUserTokenName, JSON.stringify(state));
            return state;
        case "LOGOUT_INTERNAL_USER":
            removeInternalUserToken();
            return null;
        default:
            return state;
    }
};

export default internalUserReducer;